import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { each } from 'lodash'

import { callApi } from '../services/fetchService'
import { decodeConsultation } from '../services/encodingService'
import { openConsultation } from '../actions'

import DataTable from '../components/DataTable'
import FaIcon from '../components/FaIcon'

import { message } from 'antd'



class Consultations extends Component {

    state = {
        data: [],
        loading: false
    }

    static propTypes = {
        openConsultation: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'consultations'
        }).then((data) => {
            Promise.all(data.map(x => decodeConsultation(x))).then((res) => {
                data = res
                this.setState({
                    data: each(data, (item) => {
                        item.fullName = item.firstName + ' ' + item.lastName
                    }),
                    loading: false
                })
            })
        }).catch((err) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    rowsConfig = (consultation) => ({
        style: { cursor: 'pointer' },
        onClick: (e) => {
            this.props.openConsultation(consultation)
            this.props.history.push('/patient/' + consultation.patient + '/observations')
        }
    })

    render() {
        const { data, loading } = this.state

        const columns = [
            { title: "consultations.patientColumn", dataIndex: "fullName", type: "string", sorter: true },
            { title: "consultations.dateColumn", dataIndex: "date", type: "date", sorter: true, defaultSortOrder: "descend" }
        ]

        return (
            <div>
                <h1><FaIcon icon="users" fixedWidth /> <FormattedMessage id="consultations.title" /></h1>
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" onRow={this.rowsConfig} />
            </div>
        )
    }

}

export default withRouter(injectIntl(connect(null, {
    openConsultation
})(Consultations)))


// WEBPACK FOOTER //
// ./src/views/Consultations.js